import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import './Footer.css';

export default function Footer() {
  const [info, setInfo] = useState(null);
  const year = new Date().getFullYear();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/business-info`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setInfo)
      .catch(() => {});
  }, []);

  const segments = [];
  if (info?.licenseNumber) segments.push(`License #${info.licenseNumber}`);
  if (info?.establishmentNumber) segments.push(`Establishment #${info.establishmentNumber}`);
  segments.push(`© ${year} Prancing Peony Spa`);

  return (
    <footer className="site-footer">
      {segments.join('  ·  ')}
    </footer>
  );
}
